<template>
      <div class="box mt-20">
        <div class="box-header">
          <!-- <h3>선택정보 입력</h3> -->

          <h4>반입 자산 종류 관리</h4>
          <!-- <p>차량정보, 기타 요청사항을 입력하세요</p> -->
          <small>방문객 반입 가능 자산 종류 추가가 및 활성/비활성 관리가 가능합니다.</small>
          <div class="pt-16 pb-7">
            <button class="btn btn-md line-2 mr-6" @click="addAsset()">추가</button>
            <button class="btn btn-md line-2 mr-6" @click="editAsset()" :disabled="!enableEditButton">수정</button>
          </div>
        </div>

        <div class="box-body pt-0">
          <div class="box-tbl mt-0">
            <table class="tbl no-outline no-shadow">
              <colgroup>
                <col width="42px">
                <col width="200px">
                <col width="auto">
                <col width="150px">
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <label class="md-check">
                      <input type="checkbox" class="has-value" v-model="checkAll">
                      <i class="blue"></i>
                    </label>
                  </th>
                  <th>종류</th>
                  <th>설명</th>
                  <th>활성여부</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in assetList" v-bind:key="index">
                  <td>
                    <label class="md-check" v-show="item.assetCode">
                      <input type="checkbox" class="has-value" v-model="item.checked">
                      <i class="blue"></i>
                    </label>
                  </td>
                  <td v-show="!item.isEdit || !item.uuid">{{ item.assetStr }}</td>
                  <td v-show="item.isEdit && item.uuid"><input type="text" name="설명" class="form-control" v-model="item.assetStr"></td>
                  <td v-show="!item.isEdit">{{ item.assetDescription }}</td>
                  <td v-show="item.isEdit"><input type="text" name="설명" class="form-control" v-model="item.assetDescription"></td>
                  <!--<td>{{ item.assetIsEnable }}</td>-->
                  <td class="td-compo-box" v-show="!item.isEdit">
                    <dropdown v-model="item.assetIsEnable" displayName="display" valueName="value" :datasource="isEnable" title="" :isSelectionFirstData="true" :width="130" @close="updateItem(item)"/>
                  </td>
                  <td align="center" v-show="item.isEdit">
                    <button class="btn btn-m" @click="upsertItem(item)"><i class="icon-check"></i></button>
                    <button class="btn btn-m ml-5" @click="cancel(item)"><i class="icon-close"></i></button>
                  </td>
                </tr>
                <!--수정 -->
                <!--tr>
                  <td>
                    <label class="md-check">
                      <input type="checkbox" class="has-value">
                      <i class="blue"></i>
                    </label>
                  </td>
                  <td>
                    외장하드
                  </td>
                  <td>
                    <input type="text" name="설명" class="form-control" value="외장하드 디스크립션">
                  </td>
                  <td align="center">
                    <button class="btn btn-m"><i class="icon-check"></i></button>
                    <button class="btn btn-m ml-5"><i class="icon-close"></i></button>
                  </td>
                </tr-->

                <!--추가-->
                <!--tr>
                  <td></td>
                  <td>
                    <input type="text" name="종류" class="form-control">
                  </td>
                  <td>
                    <input type="text" name="설명" class="form-control">
                  </td>
                  <td align="center">
                    <button class="btn btn-m"><i class="icon-check"></i></button>
                    <button class="btn btn-m ml-5"><i class="icon-close"></i></button>
                  </td>
                </tr-->
              </tbody>
            </table>
          </div>
        </div>
      </div>
</template>
<script>
  import PageHeader from '@/layout/PageHeader.vue'
  import dropdown from "@/components/Dropdown.vue"

  export default {
    components: {
      PageHeader,
      dropdown
    },
    watch: {
      checkAll(newVal, oldVal){
        if(newVal != oldVal)
          this.assetList.map(x=>x.checked = newVal)
      }
    },
    data() {
      return {
        tosList: null,
        copyAssetList: null,
        assetList: null,
        checkList: null,
        checkAll: false,
        isEnable: [
          {display: '비활성', value: 0},
          {display: '활성', value: 1}
        ],
        isRequired: [
          {display: '선택', value: 0},
          {display: '필수', value: 1}
        ],
        checkType: null
      }
    },
    created(){

    },
    mounted(){
      this.init();
    },
    computed: {
      // isEdit(){
      //   return (item) =>{
      //     return item.isEdit;
      //   }
      // },
      enableEditButton(){
        if(this.assetList)
          return this.assetList.filter(x => x.assetCode && x.checked).length > 0;
      }
    },
    methods: {
      init(){
        //this.getTosList();
        this.getAssetList();
        //this.getCheckList();
        //this.getCheckType();
      },
      getAssetList(){
        this.$http.get('/api/public/asset')
          .then((result) => {
            this.assetList = result.data;
          }).catch((e) =>{
          })
      },
      upsertItem(item) {
        if(item.assetCode)
          this.updateItem(item)
        else
          this.insertItem(item);

      },
      insertItem(item){
        this.$http.post('/api/public/asset', item)
          .then((result) => {
            this.noti('완료','추가되었습니다.', 'success')
            this.getAssetList();
          }).catch((e) =>{
        })
      },
      updateItem(item){
        this.$http.put('/api/public/asset', item)
          .then((result) => {
            this.noti('완료', '수정되었습니다.', 'success')
            this.getAssetList();
          }).catch((e) =>{
        })
      },
      cancel(item){
        if(item.assetCode){
          debugger;
          var restoreItem = this.copyAssetList.filter(x=> x.assetCode == item.assetCode)[0];
          if(restoreItem){
            item.assetStr = restoreItem.assetStr;
            item.assetDescription = restoreItem.assetDescription;
          }
          item.isEdit = false;
          item.checked = false;
        }
        else{
          _.remove(this.assetList, x => x.uuid && x.uuid == item.uuid)
        }
        this.$forceUpdate();
      },
      editAsset(){
        debugger;
        this.copyAssetList = this.copyNew(this.assetList);
        this.assetList.forEach(x => {
          x.isEdit = x.checked;
        });
        _.remove(this.assetList, x => x.uuid)
        this.$forceUpdate();
      },
      addAsset(){
        this.assetList.forEach(x => {
          x.checked = false;
          if(!x.uuid)
            x.isEdit = false;
        });
        let obj = {
          uuid : this.uuidv4(),
          assetCode: '',
          assetStr: '',
          assetDescription: '',
          assetIsEnable: 1,
          isEdit: true,
        };

        this.assetList.push(obj);
      }
    }
  }
</script>
<style>

</style>
